import React from "react";

const TaskTableRows = ({
  budget,
  canAddTask1,
  canEditTask,
  canDeleteTask,
  OpenModalTAllocation,
  OpenModalEdit,
  OpenModalRemove,
}) => {
  if (!budget.tasks || budget.tasks.length === 0) {
    return (
      <tr>
        <td className="text-center" colSpan="6">
          <div className="no-content-msg">
            <span>No Tasks Available</span>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <>
      {budget.tasks.map((task) => (
        <tr key={task.task_id}>
          <td className="text-start">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={() => OpenModalTAllocation(task)}
            >
              T{String(task.task_id).padStart(3, "0")}
            </button>
          </td>

          <td className="text-start">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={() => OpenModalTAllocation(task)}
            >
              {task.task_name}
            </button>
          </td>

          <td className="text-start w-50">
            {task.assignments.length > 0 ? (
              task.assignments.map((assignment, idx) => {
                const initials =
                  (assignment.first_name?.[0] || "") +
                  (assignment.last_name?.[0] || "");
                const fullName = `${assignment.first_name} ${assignment.last_name}`;

                return (
                  <span
                    key={idx}
                    className="char-square custom-tooltip"
                    data-tooltip={fullName}
                  >
                    {initials.toUpperCase()}
                  </span>
                );
              })
            ) : (
              <span className="no-data-message">No Allocations</span>
            )}
            &nbsp;
            {canAddTask1 && (
              <span
                className="char-square btn-link"
                onClick={() => OpenModalTAllocation(task)}
              >
                <i className="bi bi-plus"></i>
              </span>
            )}
          </td>

          <td className="text-start">
            {Number(task.hours_spent || 0).toFixed(2)} hrs
          </td>

          <td className="text-end">
            ${Number(task.cost_spent || 0).toFixed(2)}
          </td>

          {(canEditTask || canDeleteTask) && (
            <td className="text-end">
              <div className="d-flex justify-content-end gap-2">
                <div className="dropdown">
                  <button
                    className="btn btn-sm"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-three-dots-vertical"></i>
                  </button>

                  <ul className="dropdown-menu">
                    {canEditTask && (
                      <li
                        onClick={() =>
                          OpenModalEdit(
                            task.task_id,
                            budget.bid,
                            task.task_name,
                            task.task_type,
                            task.task_start_date,
                            task.task_end_date
                          )
                        }
                      >
                        <a className="dropdown-item" href="#">
                          Edit Task
                        </a>
                      </li>
                    )}

                    {canDeleteTask && (
                      <li onClick={() => OpenModalRemove(task.task_id)}>
                        <a className="dropdown-item" href="#">
                          Remove Task
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </td>
          )}
        </tr>
      ))}
    </>
  );
};

export default TaskTableRows;
